import {combineReducers} from '@modifi/redux'

import deleteSellerBankAccountReducer from './delete-seller-bank-account/store'
import deleteLegalRepReducer from './delete-legal-representative/store'
import deleteIntermediaryShareholderReducer from './delete-intermediary-shareholder/store'
import deleteUboReducer from './delete-beneficial-owner/store'
import deleteDirectorReducer from './delete-director/store'

export default combineReducers({
  deleteSellerBankAccount: deleteSellerBankAccountReducer,
  deleteLegalRep: deleteLegalRepReducer,
  deleteShareholdingCompany: deleteIntermediaryShareholderReducer,
  deleteUbo: deleteUboReducer,
  deleteDirector: deleteDirectorReducer,
})
